import { MStockErrorUI } from './MStockErrorUI'

export const MStockGlobalErrorUI = ({ title, buttonLabel, onRetry }) => {
  return (
    <MStockErrorUI
      title={title}
      buttonLabel={buttonLabel}
      handleClick={onRetry}
      className="min-h-screen justify-center"
    />
  )
}
